import * as React from "react";

import Lottie from "react-lottie-player";

import baseAnimation from "../../assets/ava/ava-loading-animation-base.json";
import { hexToRgbArray } from "../Common/colors";

type AvaLoadingAnimationProps = {
  isDarkMode: boolean;
  width?: number;
  height?: number;
  primaryColor?: string;
  secondaryColor?: string;
};

const injectColorsIntoAnimation = (primaryColor: string, secondaryColor: string): any => {
  let animationString = JSON.stringify(baseAnimation);

  const primaryRgb = hexToRgbArray(primaryColor);
  const secondaryRgb = hexToRgbArray(secondaryColor);

  animationString = animationString
    .replace(/"PRIMARY_COLOR"/g, JSON.stringify(primaryRgb))
    .replace(/"SECONDARY_COLOR"/g, JSON.stringify(secondaryRgb));

  return JSON.parse(animationString);
};

export const AvaLoadingAnimation = ({
  isDarkMode,
  width = 40,
  height = 40,
  primaryColor,
  secondaryColor,
}: AvaLoadingAnimationProps) => {
  const finalPrimaryColor = primaryColor || (isDarkMode ? "#FFFFFF" : "#d6194e");
  const finalSecondaryColor = secondaryColor || (isDarkMode ? "#eb6087" : "#000433");

  const animationData = React.useMemo(
    () => injectColorsIntoAnimation(finalPrimaryColor, finalSecondaryColor),
    [finalPrimaryColor, finalSecondaryColor]
  );

  return (
    <Lottie
      style={{ width, height }}
      loop
      play
      animationData={animationData}
      rendererSettings={{
        preserveAspectRatio: "xMidYMid slice",
      }}
      speed={1}
    />
  );
};
